import _ from "lodash";
import { ApplicationMimeTypesEnum } from "../../common/enums/ApplicationMimeTypesEnum";
import { LiquidProductionTATEnum } from "../../common/enums/LiquidProductionTATEnum";
import restService from "../rest-service/RestService";
import { IFilterSettings, ITankPadModel, ITankRelationshipExportOptions } from "./Models";


const TankRelationshipDataService = {

    getData: async function (contextGroupID: number,
        signal?: AbortSignal):  Promise<ITankPadModel[]> {
        const path = `/groups/${contextGroupID}/tankrelationships`;

        const response = await restService.get<ITankPadModel[]>(path, signal);


        response.data.flatMap(o => o.tankBatteries).forEach(o => {

            o.totalCapacity = _.round(o.tanks.map(v => v.capacity).reduce((a,b) => a + b, 0), 2);

            o.totalCapacityFilled = o.tags?.find(v => v.tagAssociationType.id === LiquidProductionTATEnum.CapacityFilled)?.displayText;
            
            
            // o.tanks.map(v => v.tags.find(x => x.tagAssociationType.id === LiquidProductionTATEnum.CapacityFilled))
            //                             .filter(v => v !== undefined)
            //                             .map(v => +(v!.displayText))
            //                             .reduce((a,b) => a + b, 0);


            //Matho.tanks.map(o => o.capacity)
        })


        return response.data;
    },


    exportData: async function (notificationKey: string, 
                                groupID: number, filter: IFilterSettings, mimeType: ApplicationMimeTypesEnum): Promise<void> {

        const path: string = `groups/${groupID}/tankrelationships/export`;


        // fix numbers from rivets bindging
        var bopd: number | undefined = Number(filter.BOPD);
        if (isNaN(bopd)) {
            bopd = undefined;
        }

        var bwpd: number | undefined = Number(filter.BWPD);
        if (isNaN(bwpd)) {
            bwpd = undefined;
        }

        var capacity: number | undefined = Number(filter.capacityFilled);
        if (isNaN(capacity)) {
            capacity = undefined;
        }

        var options: ITankRelationshipExportOptions = {
            notificationKey: notificationKey,
            mimeType: mimeType,
            filterType: filter.filterType,
            name: filter.name,
            capacityFilledOp: filter.capacityFilledOp,
            capacityFilled: capacity,
            BOPDOp: filter.BOPDOp,
            BOPD: bopd,
            BWPDOp: filter.BWPDOp,
            BWPD: bwpd
        };

        await  restService.post(path, options);
    }

};

export default TankRelationshipDataService;